import axios from 'axios';

// Determine if we're in production based on hostname
const isProduction = window.location.hostname !== 'localhost';

// Set appropriate API URL based on environment
const API_URL =
  process.env.REACT_APP_API_URL ||
  (isProduction
    ? 'https://dwelz.co.uk/api'
    : 'http://localhost:8080/api');

// Create axios instance with auth header
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const AdminService = {
  // Dashboard
  getDashboardStats: async () => {
    try {
      const response = await axiosInstance.get('/admin/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  // User Management
  getUsers: async (page = 1, limit = 10, search = '') => {
    try {
      const response = await axiosInstance.get('/admin/users', {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  getUser: async (userId) => {
    try {
      const response = await axiosInstance.get(`/admin/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching user ${userId}:`, error);
      throw error;
    }
  },

  updateUser: async (userId, userData) => {
    try {
      const response = await axiosInstance.put(`/admin/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error(`Error updating user ${userId}:`, error);
      throw error;
    }
  },

  // Search History
  getSearchHistory: async (page = 1, limit = 10, filters = {}) => {
    try {
      const response = await axiosInstance.get('/admin/search-history', {
        params: {
          page,
          limit,
          ...filters,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching search history:', error);
      throw error;
    }
  },

  getSearchHistoryItem: async (historyId) => {
    try {
      const response = await axiosInstance.get(`/admin/search-history/${historyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching search history item ${historyId}:`, error);
      throw error;
    }
  },

  deleteSearchHistoryItem: async (historyId) => {
    try {
      const response = await axiosInstance.delete(`/admin/search-history/${historyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting search history item ${historyId}:`, error);
      throw error;
    }
  },
};

export default AdminService;
